<template>
  <v-container fluid class="pa-0">
    <toolbar
      ref="toolbar"
      :items="datatableItems"
      :export-loading="exportLoading"
      @search="search"
      @adv-search="advancedSearch"
      @clear-search="clearSearch"
      @export="handleExport"
    />
    <datatable
      ref="datatable"
      :search="searchObject"
      @items="getDatatableItems"
      @details="openDetailsDialog"
      @images="openImagesCarousel"
      @price="openPriceDialog"
      @rr-price="openRRPriceDialog"
      @buyer-details="showBuyerDetails"
      @qr="openQrDialog"
      @actions="openActionsDialog"
      @show-notes="openNotesDialog"
      @share="openShareDialog"
      @view-car="openCarDialog"
      @view-part="openViewPartDialog"
    />
    <qr-dialog ref="qrDialog" />
    <img-carousel ref="imgCarousel" />
    <buyer-details ref="buyerDetails" />
    <price-dialog ref="priceDialog" />
    <rr-price-dialog ref="rrPriceDialog" />
    <actions-dialog ref="actionsDialog" @action-completed="getParts" />
    <notes-dialog ref="notesDialog" />
    <share-dialog ref="shareDialog" />
    <details-dialog ref="detailsDialog" />
    <car-dialog ref="carDialog" />
    <view-part ref="partDialog" @open-img-dialog="openImageDialog" />
    <img-dialog ref="imgDialog" />
  </v-container>
</template>

<script>
import Datatable from "@/components/OrderedParts/datatable.vue";
import Toolbar from "@/components/OrderedParts/toolbar.vue";
import ActionsDialog from "@/components/OrderedParts/actionsDialog.vue";

import BuyerDetails from "@/components/buyerDetails.vue";
import PriceDialog from "@/components/priceDialog.vue";
import DetailsDialog from "@/components/detailsDialog.vue";
import ImgCarousel from "@/components/imgCarousel.vue";
import QrDialog from "@/components/qrDialog.vue";
import NotesDialog from "@/components/notesDialog.vue";
import ShareDialog from "@/components/OrderedParts/shareDialog.vue";
import RRPriceIncluded from "@/components/OrderedParts/priceDialog.vue";
import CarDialog from "@/components/carDialog.vue";
import PartDetails from "@/components/OrderedParts/PartDetails.vue";
import ImgDialog from "@/components/imgDialog.vue";

export default {
  components: {
    datatable: Datatable,
    toolbar: Toolbar,
    "buyer-details": BuyerDetails,
    "details-dialog": DetailsDialog,
    "actions-dialog": ActionsDialog,
    "price-dialog": PriceDialog,
    "img-carousel": ImgCarousel,
    "qr-dialog": QrDialog,
    "notes-dialog": NotesDialog,
    "share-dialog": ShareDialog,
    "rr-price-dialog": RRPriceIncluded,
    "car-dialog": CarDialog,
    "view-part": PartDetails,
    "img-dialog": ImgDialog,
  },
  data: () => ({
    searchObject: {
      type: null,
      data: {},
    },
    datatableItems: [],
    exportLoading: false,
  }),
  mounted() {
    const { id } = this.$route.query;

    if (id) {
      const { toolbar } = this.$refs;
      toolbar.setId(id);
      toolbar.searchMethod();
    }
  },
  methods: {
    getParts() {
      // Fired when action is complete.
      if (this.searchObject.type === null) {
        this.clearSearch();
      } else if (this.searchObject.type === "regularSearch") {
        this.search(this.searchObject.data);
      } else if (this.searchObject.type === "advancedSearch") {
        this.advancedSearch(this.searchObject.data);
      }
    },

    /* Search ----------------------------------------------------------------------------------- */
    search(data) {
      this.searchObject = {
        type: "regularSearch",
        data,
      };
    },
    advancedSearch(data) {
      this.searchObject = {
        type: "advancedSearch",
        data,
      };
    },
    clearSearch() {
      this.searchObject = {
        type: null,
        data: {},
      };
    },
    /* Datatable Items -------------------------------------------------------------------------- */
    getDatatableItems(data) {
      this.datatableItems = data;
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        const parts = await this.$refs.datatable.fetchAllMatchingParts();
        this.$refs.toolbar.exportPartsToExcel(parts);
      } catch {
        this.$refs.toolbar.exportPartsToExcel(this.datatableItems);
      } finally {
        this.exportLoading = false;
      }
    },
    /* Details Dialog --------------------------------------------------------------------------- */
    openDetailsDialog(data) {
      const { detailsDialog } = this.$refs;
      detailsDialog.open(data);
    },
    /* Img Carousel ----------------------------------------------------------------------------- */
    openImagesCarousel(data) {
      const { imgCarousel } = this.$refs;
      imgCarousel.open(data);
    },
    /* Price Dialog ----------------------------------------------------------------------------- */
    openPriceDialog(data) {
      const { priceDialog } = this.$refs;
      priceDialog.open(data);
    },
    /* Buyer Details ---------------------------------------------------------------------------- */
    showBuyerDetails(data) {
      const { buyerDetails } = this.$refs;
      buyerDetails.showBuyerDetails(data);
    },
    /* QR Dialog -------------------------------------------------------------------------------- */
    openQrDialog(data) {
      const { qrDialog } = this.$refs;
      qrDialog.open(data);
    },
    /* Actions ---------------------------------------------------------------------------------- */
    openActionsDialog(data) {
      const { actionsDialog } = this.$refs;
      actionsDialog.open(data);
    },
    /* Notes dialog ----------------------------------------------------------------------------- */
    openNotesDialog(notes) {
      const { notesDialog } = this.$refs;
      notesDialog.open(notes);
    },
    /* Share Dialog ----------------------------------------------------------------------------- */
    openShareDialog(data) {
      const { shareDialog } = this.$refs;
      shareDialog.open(this.selected ? this.selectedItems : [data]);
    },
    /* RR Price included Dialog ----------------------------------------------------------------------------- */
    openRRPriceDialog(data) {
      const { rrPriceDialog } = this.$refs;
      rrPriceDialog.open(data);
    },
    /* Car Dialog ------------------------------------------------------------------------------- */
    openCarDialog(data) {
      const { carDialog } = this.$refs;
      carDialog.open(data);
    },
    /* Part details Dialog ----------------------------------------------------------------------------- */
    openViewPartDialog(data) {
      const { partDialog } = this.$refs;
      partDialog.open(data);
    },
    /* Img Dialog ------------------------------------------------------------------------------- */
    openImageDialog(image) {
      const { imgDialog } = this.$refs;
      imgDialog.open(image);
    },
  },
};
</script>
